import { TypeformLogicJumpAction } from '@/api/model/typeform/typeform-logic-jump-action'
import { TypeformMap } from '@/api/model/typeform/typeform-map'

export class TypeformLogicJump {
    constructor(
        public type: string,
        public ref: string,
        public actions: TypeformLogicJumpAction[],
    ) {}

    get alwaysAction(): TypeformLogicJumpAction|null {
        return this.actions.find(action => action.alwaysCondition)
    }

    toRequestData(): TypeformMap {
        const requestData: TypeformMap = {
            type: this.type,
            actions: this.actions.map(entry => entry.toRequestData()),
        }

        if (this.ref) {
            requestData.ref = this.ref
        }

        return requestData
    }

    static fromData(data: any): TypeformLogicJump {
        if (data === null || typeof data === 'string' || data instanceof TypeformLogicJump) {
            return data
        }

        return new TypeformLogicJump(
            data.type,
            data.ref,
            Object.values(data.actions || {}).map(entry => TypeformLogicJumpAction.fromData(entry)),
        )
    }
}
